import { http } from '@/core/api/';
import requestLocation from '@/modules/common/location.api';

const apiBaseUrl = '/api/studentexit';

export default {
  async getAcademicYears() {
    const { status, data: response } = await http.get(
      '/api/studentexit/academicyears'
    );
    return status !== 200 ? {} : response;
  },
  async getRegions(params) {
    return requestLocation.getRegions(params);
  },
  async getDistricts(params) {
    return requestLocation.getDistricts(params);
  },
  async getSchools(params) {
    return requestLocation.getSchools(params);
  },
  async getInterviews(model) {
    const studentRequest = {
      StudentSieId: model.studentSieId,
      FirstName: model.firstName,
      RegStudentId: model.regStudentId,
      Status: model.selectedQuestionnaireStatus
        ? model.selectedQuestionnaireStatus.value
        : null,
      RegionId: model.selectedRegion ? model.selectedRegion.id : null,
      AcademicYearId: model.selectedAcademicYear
        ? model.selectedAcademicYear.id
        : null,
      DistrictId: model.selectedDistrict ? model.selectedDistrict.id : null,
      LocationSchoolId: model.selectedSchool ? model.selectedSchool.id : null,
      PageIndex: model.currentPage,
      PageSize: model.pageSize,
    };
    const { status, data: response } = await http.get(
      `${apiBaseUrl}/getstudentexit`,
      {
        params: studentRequest,
      }
    );
    return status !== 200 ? {} : response;
  },
};
